import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ErrorBox } from '@common/components';
import { ICON_MAP } from './icons';
import * as styles from './Step1WidgetType.module.css';
import * as wizardStyles from './styles.module.css';

function Step1WidgetType({ widgetData, onWidgetDataChange, validationErrors, widgetTypes }) {
  const { t } = useTranslation();

  // Collect all errors for this step
  const errorMessages = [];
  if (validationErrors.title) errorMessages.push(validationErrors.title);
  if (validationErrors.type) errorMessages.push(validationErrors.type);

  return (
    <div className={styles.container}>
      <h2 className={wizardStyles.stepTitle}>{t('dashboard.widgetWizard.step1.title')}</h2>

      {/* Error Box - Show all errors at top */}
      <ErrorBox errors={errorMessages} />

      {/* Widget Name Input */}
      <input
        type="text"
        className={wizardStyles.formInput}
        value={widgetData.title}
        onChange={(e) => onWidgetDataChange('title', e.target.value)}
        placeholder={t('dashboard.widgetWizard.step1.widgetNamePlaceholder')}
      />

      {/* Visualization Type Selection */}
      <div className={styles.sectionMargin}>
        <p className={styles.selectPrompt}>{t('dashboard.widgetWizard.step1.selectPrompt')}</p>

        <div className={styles.vizGrid}>
          {widgetTypes.map(type => {
            const IconComponent = ICON_MAP[type.value];
            if (!IconComponent) return null;

            return (
              <button
                key={type.value}
                type="button"
                className={`${styles.vizCard} ${widgetData.type === type.value ? styles.selected : ''}`}
                onClick={() => onWidgetDataChange('type', type.value)}
              >
                <div className={styles.vizIcon}>
                  <IconComponent />
                </div>
                <h3 className={styles.vizTitle}>{type.label}</h3>
                <p className={styles.vizDescription}>{t(type.description)}</p>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

Step1WidgetType.propTypes = {
  widgetData: PropTypes.shape({
    title: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  onWidgetDataChange: PropTypes.func.isRequired,
  validationErrors: PropTypes.shape({
    title: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  widgetTypes: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
  })).isRequired,
};

export default Step1WidgetType;
